<template>

  <nav class="navbar-default navbar-static-side" role="navigation">
    <div class="sidebar-collapse">
      <ul class="nav metismenu" id="side-menu">

        <li class="nav-header">
          <div class="dropdown profile-element">
            <img style="width: 48px; height: 48px" src="/static/image/parkbills.png">
              <a data-toggle="dropdown" class="dropdown-toggle" href="#">
                  <span class="block m-t-xs font-bold"></span>
                  <span class="text-xs block"> Account <b class="caret"></b></span>
              </a>
              <ul class="dropdown-menu animated fadeInRight m-t-xs">
                  <li><a class="dropdown-item" href="/account">Account</a></li>
                  <!-- <li><a class="dropdown-item" href="#">Password</a></li> -->
                  <li class="dropdown-divider"></li>
                  <li><a class="dropdown-item" v-bind:href="helper.WEB_URL + '/logout'">Logout</a></li>
              </ul>
          </div>
          <div class="logo-element">
            <img style="width: 48px; height: 48px" src="/static/image/parkbills.png">
          </div>
        </li>

        <li v-for="routerFirstLevel in routeAll.filter(k => k.show)" v-bind:key="routerFirstLevel.name">
          
          <a v-if="routerFirstLevel.child && routerFirstLevel.child.length > 0" href="#">
            <i :class="routerFirstLevel.icon"></i> 
            <span class="nav-label" v-html="transformTabName(routerFirstLevel)"></span>
            <span class="fa arrow"></span>
          </a>

          <ul v-if="routerFirstLevel.child && routerFirstLevel.child.length > 0" class="nav nav-second-level collapse">
            <li v-for="routerSecondLevel in routerFirstLevel.child.filter(k => k.show)" v-bind:key="routerSecondLevel.name">

              <a v-if="routerSecondLevel.child && routerSecondLevel.child.length > 0" href="#" v-html="getSecondLevelHtml(transformTabName(routerSecondLevel))">
              </a>

              <ul v-if="routerSecondLevel.child && routerSecondLevel.child.length > 0" class="nav nav-third-level collapse">
                <li v-for="routerThirdLevel in routerSecondLevel.child" v-bind:key="routerThirdLevel.name">
                  <!-- <router-link :to="routerThirdLevel.path" v-html="routerThirdLevel.name"></router-link> -->
                  <a v-bind:href="routerThirdLevel.path" v-html="transformTabName(routerThirdLevel)"></a>
                </li>
              </ul>

              <!-- <router-link v-else :to="routerSecondLevel.path" v-html="routerSecondLevel.name"></router-link> -->
              <a v-else v-bind:href="routerSecondLevel.path" v-html="transformTabName(routerSecondLevel)"></a>

            </li>
          </ul>

          <!-- <router-link v-else :to="routerFirstLevel.path">
            <i :class="routerFirstLevel.icon"></i> 
            <span class="nav-label" v-html="routerFirstLevel.name"></span>
          </router-link> -->
          <a v-else v-bind:href="routerFirstLevel.path">
            <i :class="routerFirstLevel.icon"></i> 
            <span class="nav-label" v-html="routerFirstLevel.name"></span>
          </a>

        </li>

      </ul>
    </div>
  </nav>

</template>

<script>

import router from '@/router'
import helper from '@/components/Utility/Helper'

export default {
  name: 'TemplateSide',
  methods: {
  },
  data () {
    return {
      helper: helper,
      routeAll: []
    }
  },
  created() {
  },
  mounted: function () {
    let filterRoute = (menu) => {
      if(menu.child) {
        menu.child = menu.child.filter(k => filterRoute(k));

        if(menu.child && menu.child.length > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        return this.checkRoutePermission(menu);
      }
    };
    this.routeAll = router.routeAll.filter(k => filterRoute(k));


    this.$nextTick(() => {
      $('#side-menu').metisMenu();

      // TODO kw
      // render sidebar in App.vue - don't need codes below but
      // issue 1 - sidebar not selected when first view/after refresh
      // issue 2 - other menu won't collapase if selected a first level menu item
      // render sidebar in router-view
      // issue - sidebar not selected no matter what
      helper.setSidebar(window.location);
    });
  },
  methods: {
    transformTabName(menu) {
      if(helper.checkRoleIsParker()) {
        if(menu.name === 'Bill Management') {
          return 'Bill Summary'
        } else if(menu.name === 'Collection') {
          return 'Billing'
        }
      }
      return menu.name;
    },
    checkRoutePermission(menu) {
      if(!menu.parameter || !menu.parameter.permission) {
        return true;
      }

      if(menu.parameter.visible) {
        let visiblePermission = menu.parameter.visible;
        if(visiblePermission.startsWith('.')) {
          visiblePermission = menu.parameter.permission + visiblePermission;
        }
        if(!helper.hasPermission(visiblePermission, false)) {
          return false;
        }
      }

      if(menu.parameter.permission === 'secretadmin') {
        if(helper.checkRoleIsSecretadmin()) {
          return true;
        }
      }

      // if(menu.path === '/plTerminationPending') {
      //   if(helper.checkRoleIsParker()) {
      //     return false;
      //   }
      // }

      return helper.hasViewPermission(menu.parameter.permission, false);
    },

    getSecondLevelHtml(text) {
      return text + '<span class="fa arrow"></span>'
    },
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Template/TemplateSide.vue